import React from 'react';
import {connect} from 'react-redux';
import {CardDisplay} from '../utils/CardDisplay';
import Card from '../utils/Card';
import Repeater from '@Utils/Repeater';

import {container} from "@Container";
import {TYPES} from "@Types";
import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import {MyDrawAction} from "@Redux/actions";
import {myTeamArmies} from "@Selectors/tool/pairing/myTeamArmy";
import {TeamArmyView} from "@Selectors/tool/pairing/create/view/TeamArmyView";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const SelectArmyDraw: React.FC<SelectArmyDrawProps> = ({armies, selectArmy}) => {
  return (
    <div className="draw-step mt-2">
      <div>
        <h3 className="text-center"><FormattedMessage {...defaultMessages.toolPairingMyTeamMyArmies} /></h3>
        <div className="row list-armies justify-content-md-center">
          <Repeater data={armies} indexPrefix='army'>
            {
              (item: TeamArmyView) =>
                <Card display={CardDisplay.TEAM_ARMY}
                      selectable={true}
                      army={item}
                      my={true}
                      select={() => selectArmy(item)}/>
            }
          </Repeater>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  armies: myTeamArmies(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const drawAction = container.get<MyDrawAction>(TYPES.Actions.Tool.MyDrawAction)
  return {
    selectArmy: (teamArmy: TeamArmyView) => dispatch(drawAction.selectArmy(teamArmy.item!)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectArmyDraw);

type SelectArmyDrawProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
